
import Access from './gallery';
import './App.css';



function App() {
  return (
    <div>
<Access/>

    </div>
  );
}

export default App;
